import { httpsCallable } from 'firebase/functions';
import { functions } from './config';

// Wrapper som kaller en Cloud Function og returnerer result.data
async function call(name, data = {}) {
  const fn = httpsCallable(functions, name);
  const result = await fn(data);
  return result.data;
}

export const stripeApi = {
  createStripeCustomer:      ()             => call('createStripeCustomer'),
  createSetupIntent:         ()             => call('createSetupIntent'),
  saveDefaultPaymentMethod:  (pmId)         => call('saveDefaultPaymentMethod', { paymentMethodId: pmId }),
  removeDefaultPaymentMethod: ()            => call('removeDefaultPaymentMethod'),
  createConnectAccount:      ()             => call('createConnectAccount'),
  getConnectOnboardingUrl:   ()             => call('getConnectOnboardingUrl', { appUrl: window.location.origin }),
  getConnectStatus:          ()             => call('getConnectStatus'),
  createConnectDashboardLink: ()            => call('createConnectDashboardLink'),
  createPaymentIntent:       (orderId)      => call('createPaymentIntent', { orderId }),
  // params: { orderId, bidId, expectedAmount, attemptId, paymentIntentId? }
  acceptBid:                 (params)       => call('acceptBid', params),
  takeOrder:                 (orderId)      => call('takeOrder', { orderId }),
  refundOrder:               (orderId)      => call('refundOrder',               { orderId }),
  cancelAcceptedOrder:       (orderId)      => call('cancelAcceptedOrder',       { orderId }),
  cancelOrderByOrderer:      (orderId)      => call('cancelOrderByOrderer',      { orderId }),
};

// Krav om ventetid, bomtur og avbestillingsgebyr (beløp regnes på serveren)
export const claimsApi = {
  // { orderId, stage: 'pickup' | 'delivery' }
  registerArrival: (params) => call('registerArrival', params),
  // { orderId, kind: 'waiting' | 'bomtur' | 'cancellation', stage?, note? }
  submitClaim:     (params) => call('submitClaim', params),
  // { orderId, claimId, decision: 'approve' | 'dispute' | 'reject' }
  decideClaim:     (params) => call('decideClaim', params),
};

export const invoiceApi = {
  getInvoicePdf:     (invoiceId) => call('getInvoicePdf',     { invoiceId }),
  markInvoicePaid:   (invoiceId) => call('markInvoicePaid',   { invoiceId }),
  resendInvoiceMail: (invoiceId) => call('resendInvoiceMail', { invoiceId }),
  creditInvoice:     ({ invoiceId, netAmount, reason, expectedCreditNoteCount }) =>
    call('creditInvoice', { invoiceId, netAmount, reason, expectedCreditNoteCount }),
  markFeeInvoicePaid: ({ invoiceId, reason }) => call('markFeeInvoicePaid', { invoiceId, reason }),
};

export const adminApi = {
  sendTestNotification: (uid) => call('sendTestNotification', { uid }),
  saveMassCatalog:      (catalog, baseVersion) => call('saveMassCatalog', { catalog, baseVersion }),
};

export const activityApi = {
  logClientEvent: (event) => call('logClientEvent', event),
};

export const supportApi = {
  createFeedback:      (data) => call('createFeedback', data),
  addCaseMessage:      (data) => call('addCaseMessage', data),
  adminCreatePhoneCase: (data) => call('adminCreatePhoneCase', data),
  adminReplyToCase:    (data) => call('adminReplyToCase', data),
  adminUpdateCase:     (data) => call('adminUpdateCase', data),
};

export const carrierApi = {
  createCarrierOrg:          ()     => call('createCarrierOrg'),
  saveCarrierInvoiceProfile: (data) => call('saveCarrierInvoiceProfile', data),
  inviteCarrierMember:       (data) => call('inviteCarrierMember', data),
  respondToCarrierInvite:    (data) => call('respondToCarrierInvite', data),
  removeCarrierMember:       (data) => call('removeCarrierMember', data),
  leaveCarrierOrg:           (data) => call('leaveCarrierOrg', data),
  setCarrierMemberRole:      (data) => call('setCarrierMemberRole', data),
  createOrgMember:           (data) => call('createOrgMember', data),
  updateDriverProfile:       (data) => call('updateDriverProfile', data),
  saveOrgVehicle:            (data) => call('saveOrgVehicle', data),
  deleteOrgVehicle:          (data) => call('deleteOrgVehicle', data),
  addVehicleService:         (data) => call('addVehicleService', data),
  grantInspectionOverride:   (data) => call('grantInspectionOverride', data),
  saveCarrierCustomer:       (data) => call('saveCarrierCustomer', data),
  deleteCarrierCustomer:     (data) => call('deleteCarrierCustomer', data),
  saveCarrierPickup:         (data) => call('saveCarrierPickup', data),
  deleteCarrierPickup:       (data) => call('deleteCarrierPickup', data),
  createCarrierOrder:        (data) => call('createCarrierOrder', data),
  updateCarrierOrder:        (data) => call('updateCarrierOrder', data),
  cancelCarrierOrder:        (data) => call('cancelCarrierOrder', data),
  offerCarrierOrder:         (data) => call('offerCarrierOrder', data),
  respondToCarrierOrder:     (data) => call('respondToCarrierOrder', data),
};
